import {BeginnerModeLevel} from '@colonist/game-beginner-mode'
import {BotDifficulty, BotSpeedSettings, DiceSettingEnum, GameSpeedSettings, GameTypeEnum, MapSettingEnum, ModeSettingEnum} from '@colonist/game-base-types'
import {type BotGameCreationContext} from '@colonist/shared-types'

export function getMapForBeginnerModeLevel(level: BeginnerModeLevel) {
    switch(level) {
        case BeginnerModeLevel.Level1:
            return MapSettingEnum.CampaignLevel1
        case BeginnerModeLevel.Level2:
            return MapSettingEnum.CampaignLevel2
        case BeginnerModeLevel.End:
            throw new Error(`Invalid beginner mode level: ${level}`)
    }
}

export function getBotsForBeginnerModeLevel(level: BeginnerModeLevel): BotDifficulty[] {
    switch(level) {
        case BeginnerModeLevel.Level1:
            return []
        case BeginnerModeLevel.Level2:
            return [BotDifficulty.BotEasy]
        case BeginnerModeLevel.End:
            throw new Error(`Invalid beginner mode level: ${level}`)
    }
}

export function getVPToWinForBeginnerModeLevel(level: BeginnerModeLevel): number {
    switch(level) {
        case BeginnerModeLevel.Level1:
            return 4
        case BeginnerModeLevel.Level2:
            return 5
        case BeginnerModeLevel.End:
            throw new Error(`Invalid beginner mode level: ${level}`)
    }
}

export function getCardDiscardLimitForBeginnerModeLevel(level: BeginnerModeLevel): number {
    switch(level) {
        case BeginnerModeLevel.Level1:
            return 20
        case BeginnerModeLevel.Level2:
            return 7
        case BeginnerModeLevel.End:
            throw new Error(`Invalid beginner mode level: ${level}`)
    }
}

export function getBeginnerModeContext(level: BeginnerModeLevel, map: MapSettingEnum): BotGameCreationContext {
    const beginnerModeCreationContext: BotGameCreationContext = {
        gameTypeEnum: GameTypeEnum.BeginnerMode,
        gameSpeed: GameSpeedSettings.Base12000s,
        botSpeed: BotSpeedSettings.Normal,
        modeSetting: ModeSettingEnum.BeginnerModeClassic4P,
        diceSetting: DiceSettingEnum.Random,
        mapSetting: map,
        victoryPointsToWin: getVPToWinForBeginnerModeLevel(level),
        cardDiscardLimit: getCardDiscardLimitForBeginnerModeLevel(level),
    }
    return beginnerModeCreationContext
}

export function getWaitMSForAction(baseMS: number, actionIndex: number): number {
    const minimumMSActionIndex = 6
    const minimumMS = baseMS / 3
    if(actionIndex >= minimumMSActionIndex) return minimumMS

    const reductionPerIndex = minimumMS / minimumMSActionIndex
    return minimumMS + (reductionPerIndex * (minimumMSActionIndex - actionIndex))
}
